import request from '@/utils/request'


// 查询学校信息列表
export function listSchool(query) {
  return request({
    url: '/platform/school/list',
    method: 'get',
    params: query
  })
}

// 查询学校信息分页
export function pageSchool(query) {
  return request({
    url: '/platform/school/page',
    method: 'get',
    params: query
  })
}

// 查询学校信息详细
export function getSchool(data) {
  return request({
    url: '/platform/school/detail',
    method: 'get',
    params: data
  })
}

// 新增学校信息
export function addSchool(data) {
  return request({
    url: '/platform/school/add',
    method: 'post',
    data: data
  })
}

// 修改学校信息
export function updateSchool(data) {
  return request({
    url: '/platform/school/edit',
    method: 'post',
    data: data
  })
}

// 删除学校信息
export function delSchool(data) {
  return request({
    url: '/platform/school/delete',
    method: 'post',
    data: data
  })
}
